﻿import { type Translations } from "./fi-FI";
const LocaleSvFI: Translations = {
  HeaderInnofactorLogoAlt: 'Innofactor Signatur logo',
  HeaderLogoutButtonAlt: 'Logga ut',
  HeaderInfoButtonAlt: 'Information om tjänsten',

  Login: 'Logga in',
  LoginHeader: 'Logga in',
  Logout: 'Logga ut',
  LogoutHeader: 'Logga ut',  
  
  ScsAuthenticationDisplayName:  'Smartkort',
  EmailAuthenticationDisplayName:  'E-post',
  LoginReasonDefault:  'Påbörja signering genom att logga in',
  LoginReasonAdditionalAuthRequired:  'Fortsätt genom att välja nästa autentiseringsmetod',
  scsProcessResponseError:  'Kortläsaren svarade inte eller läsningen avbröts. Kontrollera att kortläsarprogramvaran är installerad, att den körs och att smartkortet finns i läsaren. Du kan använda informationssidan \u003ca href=\'https://localhost:53952/\'\u003ekortläsare\u003c/a\u003e för att verifiera åtgärden. Om det inte går att komma åt informationssidan är kortläsarprogramvaran inte installerad eller så körs den inte.',
  scsProcessHandlingResponse:  'Svar från kortläsaren – bearbetar...',
  scsProcessWaitingForResponse:  'Väntar på svar från kortläsaren... Följ kortläsarens instruktioner.',
  NoVisibleExternalProviders:  'Ingen identifieringsleverantör är konfigurerad för den här klienten.',
  InvalidLoginRequest:  'Ogiltig inloggningsbegäran',
  LoginReasonInvalidScsResponse:  'Kontrollera att kortläsaren är installerad, att den körs och att smartkortet finns i läsaren',
  LoginReasonExpiredError:  'Tidsgränsen för inloggningen har löpt ut',
  LoginReasonLoggedOut:  'Du har loggats ut och kan stänga webbläsaren. Om du vill kan du logga in igen.',
  ScsLoginNotAllowed:  'Smartkort är inte tillåtet för den här signaturen',
  EmailLoginNotAllowed:  'E-post är inte tillåtet för den här signaturen',
  SmsLoginNotAllowed:  'SMS är inte tillåtet för den här signaturen',
  LoginReasonInvalidScsIssuerError:  'Smartkortsutfärdare som inte stöds',
  LoginReasonUnauthorizedError:  'Du är inte rätt person att underteckna denna handling',
  LoginReasonInvalidScsResponseError:  'Problem med kortläsaren',
  LoginReasonExpired:  'Logga in igen',
  LoginReasonUnauthorized:  'Du kan prova att använda andra autentiseringsuppgifter när du loggar in',
  LoginReasonInvalidScsIssuer:  'Du kan prova att använda andra autentiseringsuppgifter när du loggar in',
  LoginReasonSigningTimeout:  'Logga in igen för att fortsätta arbeta med handlingen',
  LoginReasonErrorDuringLogin: 'Ett fel uppstod under inloggningen. Försök igen',
  
  Otp_Email_Header: 'Autentisera med e-post',
  Otp_Email_AuthenticationInfo: 'Du får en kod via e-post som du kan använda för att autentisera dig. Ange först e-postadressen som signeringsinbjudan skickades till.',
  Otp_Email_EnterUserIdentifier: "E-postadress",
  Otp_Email_SendCode: 'Skicka autentiseringskod',
  Otp_Email_UserIdentifierInvalid: 'E-postadressen matchade inte e-postadressen för signeringsinbjudan. Ange den exakta e-postadressen dit signeringsinbjudan skickades.',
  Otp_Email_CodeSent: 'Autentiseringskoden har skickats till din e-post. Kontrollera din e-post och ange autentiseringskoden nedan. Om e-postmeddelandet inte kommer fram, vänta en stund och kontrollera även din skräppostmapp.',
  Otp_Email_CannotSendCodeTooSoon: 'Ett autentiseringsmeddelande har redan skickats. Kontrollera din inkorg, inklusive skräppost. Du kan skicka en annan autentiseringskod om ett tag.',
  Otp_Email_EnterCode: 'Autentiseringskod',
  Otp_Email_CodeInvalid : 'Koden är inte giltig. Använd koden från e-postmeddelandet.',  
  Otp_Email_SubmitCode: 'Skicka',

  Otp_Sms_Header: 'Autentisera med SMS',
  Otp_Sms_AuthenticationInfo: 'Du får en kod via SMS som du kan autentisera med. Ange först mobiltelefonnumret i internationellt format (+358...), till vilket signeringsbegäran skickades.',
  Otp_Sms_EnterUserIdentifier: "Telefonnummer",
  Otp_Sms_SendCode: 'Skicka autentiseringskod',
  Otp_Sms_UserIdentifierInvalid: 'Telefonnumret du angav matchar inte telefonnumret som signeringsbegäran skickades till. Ange telefonnumret exakt och försök igen.',
  Otp_Sms_CodeSent: 'Autentiseringskoden har skickats till din telefon. Kontrollera dina meddelanden och ange autentiseringskoden nedan. Om meddelandet inte kommer fram, vänta en stund.',
  Otp_Sms_CannotSendCodeTooSoon: 'En autentiseringskod har redan skickats. Kontrollera dina meddelanden. Du kan skicka en ny autentiseringskod om en stund.',
  Otp_Sms_EnterCode: 'Autentiseringskod',
  Otp_Sms_CodeInvalid : 'Koden är inte giltig. Ange koden du fick via SMS.',  
  Otp_Sms_SubmitCode: 'Skicka',

  LanguageSelection:  'Språkval',
    //Login:  'Logga in',
  LogoutInProgress: 'Loggar ut...',

  UnauthorizedErrorHeader: 'Fel',
  UnauthorizedErrorMessage: 'Du är inte rätt person att signera detta dokument. Beställaren tillåter endast en specifik person att signera dokumentet. Om du är rätt person, se till att du är inloggad med rätt uppgifter. Om problemet kvarstår, kontakta beställaren.',
  
  Unauthorized: {
    IncorrectEmail: 'Du är inte rätt person att signera detta dokument. Beställaren tillåter endast en specifik person att signera dokumentet. Om du är rätt person, se till att du är inloggad med rätt e-postadress. Om problemet kvarstår, kontakta beställaren.',
    IncorrectSsn: 'Du är inte rätt person att signera detta dokument. Beställaren tillåter endast en specifik person att signera dokumentet. Om du är rätt person, se till att du är inloggad med rätt uppgifter. Om problemet kvarstår, kontakta beställaren.',
    IncorrectPhone: 'Du är inte rätt person att signera detta dokument. Beställaren tillåter endast en specifik person att signera dokumentet. Om du är rätt person, se till att du är inloggad med rätt telefonnummer. Om problemet kvarstår, kontakta beställaren.',
  },
  
  SignFlowNotFoundErrorMessage: 'Denna signeringsförfrågning kunde inte hittas. Kontrollera att du öppnade den här länken från e-postinbjudan utan att ändra länken. Signeringsförfrågningen kan också ha tagits bort.',
  SignFlowCanceledErrorMessage: 'Den här signeringsförfrågningen har avbrutits',
  SignFlowRejectedBySignerErrorMessage: 'Den här signeringsförfrågningen har avvisats',
  IdentityServerErrorMessage: 'Ett fel inträffade',

  LoginPrompt: 'Påbörja signering genom att logga in',
  Loading: 'Laddar',
  SkipToContent: 'Hoppa till innehåll',
  UserName: 'Användarnamn',

  SignTabButtonText: 'Signatur',
  AttachmentsTabButtonText: 'Bilagor',

  Document: 'Handling',
  AlreadySigned: 'Denna handling har redan undertecknats',
  FinalizedDocument: 'Elektroniskt signerad handling',
  WaitingForFinalization_Signer: 'Du har signerat den här handlingen. Du kan se den signerade handlingen på den här sidan när den har bearbetats. Den här sidan uppdateras automatiskt när handlingen har bearbetats. Du kan gå tillbaka till den här sidan senare med hjälp av signeringslänken.',
  WaitingForFinalization_Approver: 'Du har godkänt den här handlingen. Du kan se den signerade handlingen på den här sidan när den har bearbetats. Den här sidan uppdateras automatiskt när handlingen har bearbetats. Du kan gå tillbaka till den här sidan senare med hjälp av granskingslänken.',
  WaitingForOthers_Signer: 'Du har signerat den här handlingen. Du kan se den signerade handlingen på den här sidan när andra undertecknare har signerat. Den här sidan uppdateras automatiskt när andra undertecknare har signerat. Du kan gå tillbaka till den här sidan senare med hjälp av signeringslänken.',
  WaitingForOthers_Approver: 'Du har godkänt den här handlingen. Du kan se den signerade handlingen på den här sidan när andra undertecknare har signerat. Den här sidan uppdateras automatiskt när andra undertecknare har signerat. Du kan gå tillbaka till den här sidan senare med hjälp av granskingslänken.',
  SignFlowValidatingTitle: 'Handlingen förbereds',
  SignFlowValidating: 'Den här handlingen håller på att valideras. Den här sidan uppdateras automatiskt när handlingen har bearbetats. Du kan gå tillbaka till den här sidan senare med hjälp av signeringslänken.',
  DownloadUnsignedDocument: 'Ladda ned fil som ska signeras',
  DownloadFinalizedDocument: 'Ladda ned fil',
  DownloadFinalizedZip: 'Ladda ned dokumentet med bilagor', 
  RejectButtonText: 'Avvisa',
  BeginScsSigningButtonText: 'Påbörja signering',
  SignButtonText: 'Signera',
  ApproveButtonText: 'Markera som godkänd',
  Attachments: 'Bilagor',
  NoAttachments: 'Inga bilagor',
  Attachment: 'Bilaga',
  OpenAttachment: 'Öppna bilaga: $',
  Close: 'Stäng',

  SigningInfoHeader: 'Elektronisk signatur',
  SigningInfoSubHeader1: 'När du registrerar dig för tjänsten lagras följande information om dig',
  SigningInfoSubHeader2Signers: 'Signerare',
  SigningInfoSubHeader2Viewers: 'Delgivningsmottagare',
  SigningInfoSubHeader3Approvers: 'Granskare av handlingen',
  SigningInfoSubHeader3: 'Detaljer om signeringsförfrågning',
  SigningInfoName: 'Namn',
  SigningInfoFinnishSSN: 'Personnummer',
  SigningInfoOrganisation: 'Organisation',
  SigningInfoRole: 'Roll',
  SigningInfoNoName: 'Anonym',
  SigningInfoOpenSignTab: 'Gå till handlingen',
  SigningInfoInviterName: 'Beställarens namn',
  SigningInfoInviterEmail: 'Beställarens e-post',
  SigningInfoInvitationMessage: 'Meddelande',
  SigningInfoSignflowName: 'Namn på dokumentet',
  SigningInfoStatusPending_Approver: 'Godkännande väntar',
  SigningInfoStatusDone_Approver: 'Granskad',
  SigningInfoStatusPending_Signer: 'Väntar på undertecknande',
  SigningInfoStatusDone_Signer: 'Undertecknad',
  SigningInfoRejected: 'Avvisad',
  InfoPageUrl: 'Information om tjänsten och dataanvändning',

  SignDialogHeader: 'Signera',
  SignDialogText1: 'Signera handlingen?',
  SignDialogText2: 'Följande information om dig sparas i handlingen:',
  SignDialogField_Name: 'Namn',
  SignDialogCancelButtonText: 'Avbryt',
  SignDialogFinishScsButtonText: 'Signera',
  SignDialogSignButtonText: 'Signera',

  ApproveDialogHeader: 'Godkännande',
  ApproveDialogText1: 'Godkänn handlingen?',
  ApproveDialogText2: 'Följande information om dig sparas i handlingen:',
  ApproveDialogField_Name: 'Namn',
  ApproveDialogCancelButtonText: 'Avbryt',
  ApproveDialogFinishScsButtonText: 'Markera som godkänd',
  ApproveDialogSignButtonText: 'Markera som godkänd',

  ZipDialogHeader: 'Komprimering av filer pågår',
  ZipDialogContent: 'Zip-paketet med signerade filer förbereds fortfarande, detta kan ta en stund. Var god och försök igen senare.',
  ZipDialogClose: 'Ok',

  UserIdentifierType_FinnishSSN: "Personnummer",
  UserIdentifierType_SwedishSSN: "Personnummer",
  UserIdentifierType_NorwegianSSN: "Personnummer",
  UserIdentifierType_FinnishAuthenticatorIdentifier: "Finskt autentiserings-ID",
  UserIdentifierType_FinnishElectronicIdentificationNumber: "Elektroniskt unikt identifieringsnummer (SATU)",
  UserIdentifierType_MitIdUuid: "MitID UUID",
  UserIdentifierType_Scs: "Identifieringsinformation för smartkort",
  UserIdentifierType_EidasPersonalIdentifier: "eIDAS-identifierare",
  UserIdentifierType_Email: "E-postadress",
  UserIdentifierType_NationalSSN: "Personnummer",
  UserIdentifierType_PhoneNumber: "Telefonnummer",

  RejectDialogHeader: 'Avvisa',
  RejectDialogRejectionComment: 'Orsak till avvisning',
  RejectDialogCancelButtonText: 'Avbryt',
  RejectDialogRejectButtonText: 'Avvisa',
  SignDialogField_Procuration: 'Välj din signeringsrätt',
  SignDialogField_ProcurationRepresentative: 'Firmateckningsrätt',
  SignDialogField_ProcurationAuthority: 'Ställningsfullmakt',
  SignDialogField_ProcurationOther: 'Annan signeringsrätt',

  SigningTimedOutText: 'Logga in igen för att fortsätta arbeta med handlingen.',

  SigningInProgressDialogHeader: 'Signering',
  SigningInProgressDialogText: 'Handlingen signeras...',

  SignedDialogHeader: 'Signerat',
  SignedDialogText: 'Handlingen har signerats',

  RejectionInProgressDialogHeader: 'Avvisar',
  RejectionInProgressDialogText: 'Handlingen avvisas...',

  RejectedDialogHeader: 'Avvisad',
  RejectedDialogText: 'Handlingen har avvisats',

  SigningFailedDialogHeader: 'Signeringen misslyckades',
  RejectionFailedDialogHeader: 'Avvisning misslyckad',

  InfoPageHeading: 'Information om tjänsten',
  InfoPage: [
    { link: 'https://eur-lex.europa.eu/legal-content/FI/TXT/?uri=uriserv:OJ.L_.2014.257.01.0073.01.FIN', p: 'Denna tjänst, som heter Innofactor Signature, tillhandahåller elektroniska signaturtjänster. Underskrifterna kan vara avancerade eller kvalificerade elektroniska signaturer, enligt definitionen i eIDAS-förordningen.' },
    { heading1: 'Användning av personuppgifter' },
    { p: 'Undertecknarens namn och unika identifieringsinformation lagras i den signerade handlingen under signeringsprocessen. Den unika identifieringen kan till exempel vara personnummer, elektronisk unik identifierare (SATU), identifieringsuppgifter för smartkort eller e-postadress.' },
    { p: 'Den här informationen krävs för att signaturerna ska vara giltiga avancerade eller kvalificerade signaturer.' },
    { p: 'Beställaren av signaturen kommer att se undertecknarens information.' },
    { p: 'Undertecknare kommer att kunna se alla undertecknares namn efter att signeringsprocessen är klar. Undertecknare kommer inte att se den unika identifieringsinformationen.' },
    { p: 'Informationen som är relaterad till en signatur lagras i signaturtjänsten så länge signeringsprocessen är aktiv. När signeringsprocessen blir inaktiv tas informationen bort från signaturtjänsten.' }
  ],

  PrivacyPolicy: 'Integritetspolicy',
  OpenPrivacyPolicy: 'Öppna integritetspolicyn',

  InfoPageFeedbackUrlHeader: 'Synpunkter',
  OpenInfoPageFeedbackUrl: 'Öppna feedbackformulär',

  Error: 'Fel',
  LoginErrorDescription: 'Ett fel uppstod under inloggningen. Försök igen $here$.',

  ManualPage: [
    { heading1: 'Manual' },
    { p: 'De grundläggande funktionerna för signering beskrivs här. Bilder är exempel och kan skilja sig i utseende och innehåll från det du ser.' },
    { heading2: 'Öppnar signeringstjänsten' },
    { p: 'Öppna signeringstjänsten från inbjudnings-e-postlänken du fick.' },
    { heading2: 'Identifiering' },
    { p: 'För att autentisera till signeringstjänsten, välj en autentiseringsmetod från de tillgängliga alternativen.' },
    { img: 'auth_swe', alt: 'Identifiering' },
    { heading2: 'Signaturvy' },
    { p: 'Efter framgångsrik autentisering kommer du att kunna se handlingen som ska signeras och dess bilagor.' },
    { p: 'Använd funktionerna längst ned för att avvisa eller signera handlingen.' },
    { p: 'Du kan återgå till signaturvyn senare genom att öppna länken för e-postinbjudan igen.' },
    { img: 'preview_swe', alt: 'Signaturvy' },
    { heading2: 'Signering' },
    { p: 'Tryck på Signera för att signera handlingen. Acceptera signaturen i bekräftelsedialogrutan eller avbryt.' },
    { img: 'dialog_swe', alt: 'Signering' },
    { p: 'När alla användare har undertecknat handlingen visas en signerad version av handlingen, med försättsbladet som visar information om alla undertecknare. Den elektroniskt signerade handlingen kan sedan laddas ner längst ner på sidan.' },
    { heading2: 'Avvisning av signatur' },
    { p: 'Du kan avvisa signaturen genom att trycka på Avvisa och ange ett skäl för avvisning i bekräftelsedialogrutan.' },
    { img: 'reject_swe', alt: 'Avvisande av underskrift' },
    { heading2: 'Logga ut' },
    { p: 'Du kan logga ut med dörrikonen i det övre högra hörnet.' },
    { img: 'logout', alt: 'Logga ut' },
  ],
  
  AccessibilityPageHeading: 'Tillgänglighetsförklaring',
  OpenAccessibilityStatement: 'Öppna tillgänglighetsförklaring',

  AccessibilityPage: [
    { heading1: 'Tillgänglighetsförklaring' },
    { p: 'Denna sida har inte översatts ännu. Välj ett annat språk.' },
  ],

  LoginError: {
    HeaderText: 'Inloggning misslyckades',
    DefaultReason: 'Det uppstod ett fel vid inloggningen. Du kan försöka igen genom att öppna signaturlänken på nytt. Om felet upprepas, ta bort eventuella tillägg i webbläsaren eller försök med en annan webbläsare. Se också till att cookies är tillåtna. Om problemet inte löser sig, kontakta den som begärde signaturen.',
  }
}
export default LocaleSvFI;
